import Link from "next/link";
import clsx from "clsx";

interface Props {
    children: React.ReactNode;
    href?: string;
    className?: string;
    variant?: "primary" | "secondary" | "tertiary" | "modal" | "modal-pill";
    position?: "left";
    target?: "_blank" | "_self";
    rel?: string;
    onModalOpen?: (modalTitle?: string) => void;
    modalTitle?: string;
}

const Hyperlink = ({
    children = "Hyperlink",
    href,
    className,
    variant,
    position,
    target,
    rel,
    onModalOpen,
    modalTitle,
}: Props) => {
    // Check if it's a modal variant
    const isModal = variant === "modal" || variant === "modal-pill";
    
    // Check if it's an external link (only for non-modal variants)
    const isExternal = !isModal && href && (href.startsWith('http') || href.startsWith('https'));
    
    const handleClick = (e: React.MouseEvent) => {
        if (isModal) {
            e.preventDefault();
            e.stopPropagation();
            onModalOpen?.(modalTitle);
        }
        // For non-modal variants, let the default behavior handle it
    };
    
    const buttonClassName = clsx(
        "desilo-link-btn",
        {
            "btn-pill": variant === "primary" || variant === "modal-pill",
            "btn-dark": variant === "secondary",
            "btn-pill btn-light": variant === "tertiary",
            // modal variant has no additional styling - just base desilo-link-btn
        },
        className
    );
    
    const linkProps = {
        className: buttonClassName,
        ...(isExternal && target && { target }),
        ...(isExternal && rel && { rel }),
    };
    
    const linkPropsWithHref = {
        ...linkProps,
        href: href!,
    };

    const linkContent = (
        <>
            {position === "left" && (
                <span>
                    <i className="fa-solid fa-arrow-left arry1" />
                    <i className="fa-solid fa-arrow-left arry2" />
                </span>
            )}

            {children}
            {position !== "left" && (
                <span>
                    <i className="fa-solid fa-arrow-right arry1" />
                    {/* <i className="fa-solid fa-arrow-right arry2" /> */}
                </span>
            )}
        </>
    );

    return (
        <>
            {isModal ? (
                <div 
                    {...linkProps}
                    onClick={handleClick}
                >
                    {linkContent}
                </div>
            ) : isExternal ? (
                <a {...linkPropsWithHref}>
                    {linkContent}
                </a>
            ) : href ? (
                <Link {...linkPropsWithHref}>
                    {linkContent}
                </Link>
            ) : (
                <div         
                    {...linkProps}
                >
                    {linkContent}
                </div>
            )}
        </>
    );
};

export default Hyperlink;
